import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import styles from "./Loader.module.scss";

interface LoaderProps {
  show: boolean;
}

const Loader: React.FC<LoaderProps> = ({ show }: LoaderProps) => {
  return (
    <Backdrop className={styles.backdrop} open={show}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loader;
